// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyARd5wzApA6U4ibwMIjybw7KBv01kfqCuU",
    authDomain: "batista-web.firebaseapp.com",
    projectId: "batista-web",
    storageBucket: "batista-web.appspot.com",
    messagingSenderId: "800359913765",
    appId: "1:800359913765:web:b624f265fc50feaae222cc",
    measurementId: "G-K38LBG7EJE"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
